import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useApprovalPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, scenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		scenarioId: _scenarioId,
		...useQuery(() => new q.ApprovalPageQueryV1(_workspaceId.value, _tchProjectId.value, _scenarioId.value))
	}
	return {
		...result,
		runApprovalPageQueryV1: result.run,
		modelApprovalPageQueryV1: result.model,
	}
}

export function useCriteriaPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, scenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		scenarioId: _scenarioId,
		...useQuery(() => new q.CriteriaPageQueryV1(_workspaceId.value, _tchProjectId.value, _scenarioId.value))
	}
	return {
		...result,
		runCriteriaPageQueryV1: result.run,
		modelCriteriaPageQueryV1: result.model,
	}
}

export function useExistingScenarioSettingsQueryV1(workspaceId?: number | Ref<number>, portfolioId?: string | Ref<string>, portfolioScenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>(portfolioId)
	const _portfolioScenarioId = isRef<string>(portfolioScenarioId) ? portfolioScenarioId : ref<string>(portfolioScenarioId)
	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		portfolioScenarioId: _portfolioScenarioId,
		...useQuery(() => new q.ExistingScenarioSettingsQueryV1(_workspaceId.value, _portfolioId.value, _portfolioScenarioId.value))
	}
	return {
		...result,
		runExistingScenarioSettingsQueryV1: result.run,
		modelExistingScenarioSettingsQueryV1: result.model,
	}
}

export function useNewScenarioSettingsQueryV1(workspaceId?: number | Ref<number>, portfolioId?: string | Ref<string>, corporateScenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>(portfolioId)
	const _corporateScenarioId = isRef<string>(corporateScenarioId) ? corporateScenarioId : ref<string>(corporateScenarioId)
	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		corporateScenarioId: _corporateScenarioId,
		...useQuery(() => new q.NewScenarioSettingsQueryV1(_workspaceId.value, _portfolioId.value, _corporateScenarioId.value))
	}
	return {
		...result,
		runNewScenarioSettingsQueryV1: result.run,
		modelNewScenarioSettingsQueryV1: result.model,
	}
}

export function usePnlPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, scenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		scenarioId: _scenarioId,
		...useQuery(() => new q.PnlPageQueryV1(_workspaceId.value, _tchProjectId.value, _scenarioId.value))
	}
	return {
		...result,
		runPnlPageQueryV1: result.run,
		modelPnlPageQueryV1: result.model,
	}
}

export function usePortfolioScenarioPnlQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, scenarioId?: string | Ref<string>, applyBenefitsConfidenceFactor?: boolean | Ref<boolean>, pnlTemplateId?: string | Ref<string>, denomination?: any | Ref<any>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>(applyBenefitsConfidenceFactor)
	const _pnlTemplateId = isRef<string>(pnlTemplateId) ? pnlTemplateId : ref<string>(pnlTemplateId)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>(denomination)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		scenarioId: _scenarioId,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,
		pnlTemplateId: _pnlTemplateId,
		denomination: _denomination,
		...useQuery(() => new q.PortfolioScenarioPnlQueryV1(_workspaceId.value, _tchProjectId.value, _scenarioId.value, _applyBenefitsConfidenceFactor.value, _pnlTemplateId.value, _denomination.value))
	}
	return {
		...result,
		runPortfolioScenarioPnlQueryV1: result.run,
		modelPortfolioScenarioPnlQueryV1: result.model,
	}
}

export function usePortfolioScenariosPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		...useQuery(() => new q.PortfolioScenariosPageQueryV1(_workspaceId.value, _tchProjectId.value))
	}
	return {
		...result,
		runPortfolioScenariosPageQueryV1: result.run,
		modelPortfolioScenariosPageQueryV1: result.model,
	}
}

export function useProjectsPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, scenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		scenarioId: _scenarioId,
		...useQuery(() => new q.ProjectsPageQueryV1(_workspaceId.value, _tchProjectId.value, _scenarioId.value))
	}
	return {
		...result,
		runProjectsPageQueryV1: result.run,
		modelProjectsPageQueryV1: result.model,
	}
}

export function useResourceConstraintPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, scenarioId?: string | Ref<string>, resourceId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const _resourceId = isRef<string>(resourceId) ? resourceId : ref<string>(resourceId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		scenarioId: _scenarioId,
		resourceId: _resourceId,
		...useQuery(() => new q.ResourceConstraintPageQueryV1(_workspaceId.value, _tchProjectId.value, _scenarioId.value, _resourceId.value))
	}
	return {
		...result,
		runResourceConstraintPageQueryV1: result.run,
		modelResourceConstraintPageQueryV1: result.model,
	}
}

export function useReviewPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, scenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		scenarioId: _scenarioId,
		...useQuery(() => new q.ReviewPageQueryV1(_workspaceId.value, _tchProjectId.value, _scenarioId.value))
	}
	return {
		...result,
		runReviewPageQueryV1: result.run,
		modelReviewPageQueryV1: result.model,
	}
}

export function useScenarioProjectPlanPickerQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, scenarioId?: string | Ref<string>, projectId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		scenarioId: _scenarioId,
		projectId: _projectId,
		...useQuery(() => new q.ScenarioProjectPlanPickerQueryV1(_workspaceId.value, _tchProjectId.value, _scenarioId.value, _projectId.value))
	}
	return {
		...result,
		runScenarioProjectPlanPickerQueryV1: result.run,
		modelScenarioProjectPlanPickerQueryV1: result.model,
	}
}

export function useSchedulingPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, scenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		scenarioId: _scenarioId,
		...useQuery(() => new q.SchedulingPageQueryV1(_workspaceId.value, _tchProjectId.value, _scenarioId.value))
	}
	return {
		...result,
		runSchedulingPageQueryV1: result.run,
		modelSchedulingPageQueryV1: result.model,
	}
}

export function useSelectionPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, scenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		scenarioId: _scenarioId,
		...useQuery(() => new q.SelectionPageQueryV1(_workspaceId.value, _tchProjectId.value, _scenarioId.value))
	}
	return {
		...result,
		runSelectionPageQueryV1: result.run,
		modelSelectionPageQueryV1: result.model,
	}
}

export function useSelectorSettingsQueryV1(workspaceId?: number | Ref<number>, portfolioId?: string | Ref<string>, scenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>(portfolioId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		scenarioId: _scenarioId,
		...useQuery(() => new q.SelectorSettingsQueryV1(_workspaceId.value, _portfolioId.value, _scenarioId.value))
	}
	return {
		...result,
		runSelectorSettingsQueryV1: result.run,
		modelSelectorSettingsQueryV1: result.model,
	}
}

